export const AWARD_FIELDS: Array<any> = [
	{
		id: '031682436',
		name: 'Details',
		route: 'detail'
	},
	{
		id: '031682436',
		name: 'Award Letter',
		route: 'letter'
	},
	{
		id: '031682436',
		name: 'Contract',
		route: 'contract'
	},
	{
		id: '031682436',
		name: 'Completion Certificate',
		route: 'certificate'
	}
];
